var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiPointInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.48,42.68a1,1,0,0,0-1,1v3.92H2V6.33H7.66v2a1,1,0,0,0,1,1H25.89a1,1,0,0,0,1-1v-2h5.62v4.92a1,1,0,0,0,2,0V5.35a1,1,0,0,0-1-1H26.13a.93.93,0,0,0-.24,0H24.52A4.91,4.91,0,0,0,19.72.44H14.81A4.93,4.93,0,0,0,10,4.32H8.64a1,1,0,0,0-.24,0H1.06a1,1,0,0,0-1,1V48.58a1,1,0,0,0,1,1H33.48a1,1,0,0,0,1-1V43.67A1,1,0,0,0,33.48,42.68ZM14.81,2.41h4.91a2.94,2.94,0,0,1,2.76,1.91H12.05A3,3,0,0,1,14.81,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79,14.19a1,1,0,0,0-1-1H8.92a1,1,0,0,0-1,1v5.9a1,1,0,0,0,1,1h5.89a1,1,0,0,0,1-1Zm-2,4.92H9.9V15.18h3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79,26a1,1,0,0,0-1-1H8.92a1,1,0,0,0-1,1v5.9a1,1,0,0,0,1,1h5.89a1,1,0,0,0,1-1Zm-2,4.91H9.9V27h3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.81,36.79H8.92a1,1,0,0,0-1,1v5.9a1,1,0,0,0,1,1h5.89a1,1,0,0,0,1-1v-5.9A1,1,0,0,0,14.81,36.79Zm-1,5.89H9.9V38.75h3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.65,14A13.27,13.27,0,1,0,49.92,27.28,13.27,13.27,0,0,0,36.65,14Zm8.17,7L36,35.15a1,1,0,0,1-.62.44l-.21,0a1,1,0,0,1-.54-.16l-5.9-3.93a1,1,0,0,1-.27-1.37,1,1,0,0,1,1.36-.27l5.05,3.37L43.15,20a1,1,0,0,1,1.67,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiPointInspection);
export default __webpack_public_path__ + "static/media/MultiPointInspection.c05ef843.svg";
export { ForwardRef as ReactComponent };